import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-label="Garantie de remboursement" className="bg-white" data-id="element-103" data-mp="1o46konudlsx5">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-16 text-center lg:py-20" style={{
      paddingTop: "11px",
      paddingBottom: "23px"
    }} data-id="element-104" data-mp="1o5zq5zt9673k">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-perf/15" data-id="element-105" data-mp="1x5muatdd9r0b">
          <ShieldCheckIcon className="h-8 w-8 text-perf-deep" aria-hidden="true" data-id="element-106" data-mp="19fismrjqo1by" />
        </span>
        <h2 className="mt-6 font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-107" data-mp="14gpgp3k3oidw">
          Garantie de remboursement de 7 jours
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-navy/75" data-id="element-108" data-mp="1edbxnh9b2pan">
          Nous voulons que vous puissiez découvrir le système et déterminer s'il correspond à vos besoins.
        </p>
        <p className="mt-4 text-[17px] leading-relaxed text-navy/75" data-id="element-109" data-mp="lpg2wi3ar7gi">
          Si, pendant les sept premiers jours, vous décidez que LE SYSTÈME TRIATHLON LONGUE DISTANCE™ ne vous
          convient pas, vous pouvez demander un remboursement conformément aux conditions applicables de la garantie.
        </p>
        <p className="mt-4 text-[17px] leading-relaxed text-navy/75" data-id="element-110" data-mp="yot4s36hozeu">
          Vous pouvez ainsi découvrir le contenu sans prendre un engagement financier à long terme.
        </p>
        <p className="mt-6 text-sm font-bold uppercase tracking-[0.2em] text-navy" data-id="element-111" data-mp="60nkfhjclcfj">
          SIGMA SMART™ s'engage à proposer des ressources numériques structurées et pratiques.
        </p>
      </div>
    </section>;
}